<template>
  <div 
    class="relative text-white shadow-md rounded-xl p-6 h-full flex flex-col group"
    :style="{ backgroundImage: 'linear-gradient(to bottom, #FED803, #D91C5E)' }"
  >
    <div class="absolute top-4 right-4 bg-white/20 p-2 rounded-lg transition-transform duration-300 ease-in-out group-hover:scale-110 group-hover:rotate-6">
       <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
       </svg>
    </div>
    <div class="flex justify-between items-center border-b border-white/20 pb-4">
      <h2 class="text-xl font-semibold">Production Workflow</h2>
    </div>
    <div v-if="loading" class="mt-4 text-center"><p>Loading guide...</p></div>
    <div v-else class="mt-4 prose-invert max-w-none flex-grow">
      <div v-if="!editMode" v-html="guideHtmlContent"></div>
      <textarea v-else v-model="editableContent" class="w-full h-full p-2 border border-gray-300 rounded-md focus:ring-brand-pink focus:border-brand-pink text-gray-800"></textarea>
    </div>
    <!-- START: WRAPPED BUTTONS IN V-IF -->
    <div v-if="isSuperAdmin" class="pt-4 mt-auto">
       <div v-if="!editMode">
        <button @click="enterEditMode" class="w-full text-sm bg-white/20 px-3 py-2 rounded-md hover:bg-white/30">Edit Guide</button>
      </div>
      <div v-else class="flex space-x-2">
        <button @click="cancelEdit" class="flex-1 text-sm bg-white/20 px-3 py-2 rounded-md hover:bg-white/30">Cancel</button>
        <button @click="saveContent" :disabled="isSaving" class="flex-1 text-sm bg-brand-pink px-3 py-2 rounded-md hover:opacity-90 disabled:opacity-50">
          <span v-if="isSaving">Saving...</span>
          <span v-else>Save Changes</span>
        </button>
      </div>
    </div>
    <!-- END: WRAPPED BUTTONS IN V-IF -->
  </div>
</template>

<script>
import { db } from '@/firebase';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import showdown from 'showdown';
import { mapGetters } from 'vuex'; // --- NEW: Import mapGetters

export default {
  name: 'ProductionChecklist',
  data() {
    return {
      guideMarkdown: '', loading: true, unsubscribe: null,
      editMode: false, editableContent: '', isSaving: false,
    }
  },
  computed: {
    ...mapGetters(['isSuperAdmin']), // --- NEW: Add isSuperAdmin getter
    guideHtmlContent() {
      const converter = new showdown.Converter();
      return converter.makeHtml(this.guideMarkdown);
    }
  },
  methods: {
    enterEditMode() {
      this.editableContent = this.guideMarkdown;
      this.editMode = true;
    },
    cancelEdit() {
      this.editableContent = '';
      this.editMode = false;
    },
    async saveContent() {
      this.isSaving = true;
      const guideRef = doc(db, 'content', 'productionGuide');
      try {
        await updateDoc(guideRef, {
          body: this.editableContent
        });
        this.editMode = false;
      } catch (error) {
        console.error("Error updating guide content:", error);
        alert("Failed to save the guide. Please try again.");
      } finally {
        this.isSaving = false;
      }
    }
  },
  created() {
    const guideRef = doc(db, 'content', 'productionGuide');
    this.unsubscribe = onSnapshot(guideRef, (docSnap) => {
      if (docSnap.exists()) {
        this.guideMarkdown = docSnap.data().body;
      } else {
        this.guideMarkdown = 'Guide content not found. Please contact support.';
      }
      this.loading = false;
    }, (error) => {
      console.error("Error fetching guide content:", error);
      this.guideMarkdown = 'Error loading guide content.';
      this.loading = false;
    });
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
}
</script>

<style scoped>
.prose-invert :deep(ul) { list-style-type: disc; padding-left: 1.5em; }
.prose-invert :deep(ol) { list-style-type: decimal; padding-left: 1.5em; }
.prose-invert :deep(li) { margin-bottom: 0.5em; }
.prose-invert :deep(h3) { font-weight: 600; margin-top: 1.5em; margin-bottom: 0.75em; }
.prose-invert :deep(strong) { font-weight: bold; }
.prose-invert textarea {
  box-sizing: border-box;
  resize: vertical;
  min-height: 400px;
}
</style>